import { Http } from '../Utils/Http';
import { AxiosResponse } from 'axios';
import {
  IReportCreateAxiosResponse,
  IRequestReportEmailSettings,
  IReportUpdateAxiosResponse,
  IReportEmailSettings
} from './interfaces/Preferences/IReport';

export class ReportEmailsApiV2 {
  static async getReportEmails(): Promise<AxiosResponse<IReportEmailSettings>> {
    const axios = await Http.axios();
    return axios.get("/v2/report-emails/settings");
  }

  static async createReportEmails(data: IRequestReportEmailSettings): Promise<AxiosResponse<IReportCreateAxiosResponse>> {
    const axios = await Http.axios();
    return axios.post("/v2/report-emails/settings", data);
  }

  static async updateReportEmails(data: IRequestReportEmailSettings): Promise<AxiosResponse<IReportUpdateAxiosResponse>> {
    const axios = await Http.axios();
    return axios.put("/v2/report-emails/settings", data);
  }
}
